import React from 'react'

const HandScroller: React.FC<{
  enabled: boolean
  onScrollUpdate: (intensity: number) => void // -1.0 (max left) to 1.0 (max right), 0 = stop
}> = ({ enabled, onScrollUpdate }) => {
  if (!enabled) return null

  // Use constant medium speed (0.5) for smooth, predictable scrolling
  const SCROLL_SPEED = 0.5;

  const handleMouseEnter = (direction: 'left' | 'right') => {
    onScrollUpdate(direction === 'left' ? -SCROLL_SPEED : SCROLL_SPEED);
  }

  return (
    <>
      <div
        className="absolute left-0 top-0 h-full w-80 z-20"
        onMouseEnter={() => handleMouseEnter('left')}
        onMouseLeave={() => onScrollUpdate(0)}
      />
      <div
        className="absolute right-0 top-0 h-full w-80 z-20"
        onMouseEnter={() => handleMouseEnter('right')}
        onMouseLeave={() => onScrollUpdate(0)}
      />
    </>
  )
}

export default HandScroller

